import { RegistrationInfo, RegistrationMaterial } from '@interfaces/Student'
import { PROGRAM_TYPES } from '@utils/constants'
import { getStorageAdapter, PORTAL_KEYS } from '@shell/adapters/storage'

/** Returns value only if it is a plain non-null object (guards against raw strings from corrupted storage). */
const asRecord = (value: unknown): Record<string, any> => {
  return value !== null && typeof value === 'object' && !Array.isArray(value) ? (value as Record<string, any>) : {}
}

export const getStoredMaterials = (sfId?: string) => {
  // get() already parses JSON objects — no JSON.parse wrapper needed.
  // asRecord() guards against corrupted / non-object values (e.g. raw 'invalid-json' string).
  const all = asRecord(getStorageAdapter().get<Record<string, any>>(PORTAL_KEYS.SELECTED_MATERIAL))
  return sfId ? all[sfId] : all
}

export const getStoredPrograms = (sfId?: string) => {
  const all = asRecord(getStorageAdapter().get<Record<string, any>>(PORTAL_KEYS.SELECTED_PROGRAM))
  return sfId ? all[sfId] : all
}

export const getStoredRegistrations = (sfId?: string) => {
  const all = asRecord(getStorageAdapter().get<Record<string, any>>(PORTAL_KEYS.SELECTED_REGISTRATION))
  return sfId ? all[sfId] : all
}

export const IsOnDemand = (material: RegistrationMaterial | RegistrationInfo) => {
  return [...PROGRAM_TYPES.ON_DEMAND, ...PROGRAM_TYPES.ON_DEMAND_1].indexOf(material?.ProgramType || '') >= 0
}

export const IsJapanFlex = (material: RegistrationMaterial | RegistrationInfo) => {
  return (
    (!(material as RegistrationMaterial)?.ProgramId ||
      (!(material as RegistrationInfo)?.Programs && !(material as RegistrationInfo)?.Programs?.length)) &&
    [...PROGRAM_TYPES.JPN_FLEX, ...PROGRAM_TYPES.FLEX].indexOf(material?.ProgramType || '') >= 0
  )
}

export const FlexProgram = (material: RegistrationMaterial | RegistrationInfo) => {
  return (
    material?.ProgramType &&
    PROGRAM_TYPES.FLEX.some((program) => program.toLowerCase().includes((material?.ProgramType || '').toLowerCase()))
  )
}

export const IsFlex = (material?: RegistrationMaterial | RegistrationInfo) => {
  return material ? FlexProgram(material) || IsJapanFlex(material) || IsOnDemand(material) : false
}
